import axios, { AxiosError } from "axios";
import { getToken, UNAUTHORIZED_EVENT } from "@/auth/storage";

const baseURL =
  import.meta.env.VITE_REDIRECTAPI_URL ?? "https://redirectapi.crowlingo.com";

export const apiClient = axios.create({
  baseURL,
  headers: { "Content-Type": "application/json" },
});

apiClient.interceptors.request.use((config) => {
  const token = getToken();
  if (token) {
    config.headers.set("X-API-Key", token);
  }
  return config;
});

apiClient.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => {
    if (error.response?.status === 401) {
      window.dispatchEvent(new Event(UNAUTHORIZED_EVENT));
    }
    return Promise.reject(error);
  },
);
